import React from 'react';

export function ScopelyIcon() {
  return (
    <svg
      className="mr-[10px]"
      fill="none"
      height="18"
      viewBox="0 0 14 18"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.294 17.949L1.72 8.376V0l9.573 9.571v8.378z" fill="#95A9A6" />
      <path
        d="M1.724.001h11.294L7.372 5.649 1.724 0zM11.294 17.949H0l5.646-5.645 5.648 5.645z"
        fill="#A0B7B3"
      />
    </svg>
  );
}
